module.exports = __webpack_public_path__ + "ly.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ly.svg
// module id = 674
// module chunks = 0